import { mutation } from 'gql-query-builder'
import { pathOr } from 'ramda'

import StorefrontApi from '@/apis/storefront'

const CheckoutApis = {
  createCheckoutWithItem: (user, itemVariantId) =>
    StorefrontApi.request(
      mutation({
        operation: 'checkoutCreate',
        variables: {
          input: {
            type: 'CheckoutCreateInput!',
            value: {
              email: user.email,
              customAttributes: [
                {
                  key: 'userId',
                  value: user.userId,
                },
              ],
              lineItems: [
                {
                  quantity: 1,
                  variantId: btoa(
                    `gid://shopify/ProductVariant/${itemVariantId}`,
                  ),
                },
              ],
            },
          },
        },
        fields: [
          {
            checkout: ['webUrl'],
          },
        ],
      }),
    ).then(pathOr('', ['checkoutCreate', 'checkout', 'webUrl'])),
}

export default CheckoutApis
